import api from '../../api/index'

export default {
    initialize({ state, commit }) {
        var colors = state.theme.colors
        commit('SET_COLORS', colors)
    },
    async fetchProfile({ commit }) {
        var favourites = await api.profile.getFavouriteAccounts()
        commit('SET_FAVOURITE_ACCOUNTS', favourites)
    },
    async fetchPosts({ commit }) {
        var posts = await api.profile.getPosts()
        commit('SET_POSTS', posts)
    },
    async addFavouriteAccount({ commit }, account) {
        await api.profile.addFavouriteAccount(account.id)
        commit('ADD_FAVOURITE_ACCOUNT', {
            id: account.id,
            name: account.name
        })
    },
    async removeFavouriteAccount({ commit }, account) {
        await api.profile.removeFavouriteAccount(account.id)
        commit('REMOVE_FAVOURITE_ACCOUNT', account.id)
    }
}
